
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
const Chart = require("chart.js");
const Utils = require("chart.js");

@Component
export default class OrderVolumePerManufacturerReport extends Vue {
	private chart: any = null;
	private fertigers: any = [];
	private reports: any = [];
	private loading: boolean = false;
	private year: number = new Date().getFullYear();

	private mounted() {
		this.loadReport();
	}

	private get years() {
		var lastYears = [];
		for (let index = new Date().getFullYear(); index >= 2012; index--) {
			lastYears.push(index);
		}
		return lastYears;
	}

	@Watch("year")
	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetOrderVolumePerManufacturer?year=${this.year}`
			);
			const manufacturersResponse = await httpClient().get(`Manufacturer/GetManufacturers`);
			manufacturersResponse.data.sort((a: any, b: any) => a.id - b.id);
			this.fertigers = manufacturersResponse.data;
			this.reports = response.data;
			console.log(this.fertigers);
			for (const report of this.reports) {
				for (const orderVolume of report.orderVolumes) {
					const fertiger = this.fertigers.filter(
						(m: any) => m.id === orderVolume.fertigerId
					)[0];
					if (fertiger !== undefined) {
						orderVolume.fertigerId = fertiger.name;
					} else {
						console.log(report);
					}
				}
			}
			this.updateDiagram();
		} catch (err) {
			console.error("Loading order volume reports failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private getDatasets() {
		const colors = [
			"#635147",
			"#EFBB20",
			"#704214",
			"#468641",
			"#A3FF00",
			"#00F4C4",
			"#123524",
			"#007EFF",
			"#005A99",
			"#4B0082",
			"#A146FF",
			"#FF0090",
			"#FF2400",
		];
		const relevantFertigers = this.fertigers.filter((f: any) =>
			this.getData(f.name).some((e: number) => e > 0)
		);
		var datasets: any = [
			...relevantFertigers.map((f: any, index: number) => {
				const fertigerSet = {
					label: f.name,
					data: this.getData(f.name),
					backgroundColor: colors[index],
				};
				return fertigerSet;
			}),
		];

		return datasets;
	}

	private getData(fertiger: string) {
		const data = [];
		for (const report of this.reports) {
			const orderOfFertiger = report.orderVolumes.filter(
				(order: any) => order.fertigerId == fertiger
			);
			if (orderOfFertiger.length > 0) {
				data.push(orderOfFertiger[0].total);
			} else {
				data.push(0);
			}
		}
		return data;
	}

	private updateDiagram() {
		const labels = this.reports.map(
			(r: any) => `${new Date(r.from).getMonth() + 1}.${new Date(r.from).getFullYear()}`
		);

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "line",
			// The data for our dataset
			data: {
				labels: labels,
				datasets: this.getDatasets(),
			},
			options: {
				plugins: {
					title: {
						display: true,
						text: "Umsatz",
					},
				},
				responsive: true,
				scales: {
					xAxes: [
						{
							stacked: true,
						},
					],
					yAxes: [
						{
							stacked: true,
						},
					],
				},
			},
		});
		this.chart.update();
	}
}
